import { render, staticRenderFns } from "./active.vue?vue&type=template&id=56443ea8"
import script from "./active.vue?vue&type=script&lang=js"
export * from "./active.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports